// PageType.jsx
import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Redirections from '../../constants/routes';

// ---------- Helper ----------
function renderEither({ routeProps, render, Component, extraProps = {} }) {
  const merged = { ...routeProps, ...extraProps };
  if (render) return render(merged);
  if (Component) return <Component {...merged} />;
  return null;
}

// ---------- Private ----------
const PrivateRoute = ({ component: Component, render, ...rest }) => {
  const authed = !!useSelector(s => s.auth.authenticated);
  const activeAccount = !!useSelector(s => s.auth.active);

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!authed) {
          return (
            <Redirect
              to={{ pathname: Redirections.ROUTE_LINK_HOME.partial, state: { from: props.location } }}
            />
          );
        }

        if (
          authed &&
          !activeAccount &&
          props.location.pathname !== Redirections.ROUTE_LINK_ACTIVATE_ACCOUNT.partial
        ) {
          return (
            <Redirect
              to={{ pathname: Redirections.ROUTE_LINK_ACTIVATE_ACCOUNT.partial, state: { from: props.location } }}
            />
          );
        }

        if (
          authed &&
          activeAccount &&
          props.location.pathname === Redirections.ROUTE_LINK_ACTIVATE_ACCOUNT.partial
        ) {
          return (
            <Redirect
              to={{ pathname: Redirections.ROUTE_LINK_DASHBOARD.partial, state: { from: props.location } }}
            />
          );
        }

        return renderEither({ routeProps: props, render, Component });
      }}
    />
  );
};

// ---------- Public ----------
const PublicRoute = ({ component: Component, render, ...rest }) => {
  const authed = !!useSelector(s => s.auth.authenticated);

  return (
    <Route
      {...rest}
      render={(props) =>
        authed === false
          ? renderEither({ routeProps: props, render, Component })
          : (
            <Redirect
              to={{ pathname: Redirections.ROUTE_LINK_DASHBOARD.partial, state: { from: props.location } }}
            />
          )
      }
    />
  );
};

// ---------- Open (logged in or out) ----------
const OpenRoute = ({ component: Component, render, ...rest }) => {
  const authed = !!useSelector(s => s.auth.authenticated);

  return (
    <Route
      {...rest}
      render={(props) =>
        renderEither({
          routeProps: props,
          render,
          Component,
          extraProps: { auth: authed },   // <-- inject here
        })
      }
    />
  );
};

// ---------- NoPath ----------
const NoPath = ({ component: Component, ...rest }) => {
  const authed = !!useSelector(s => s.auth.authenticated);
  return (
    <Route
      {...rest}
      render={(props) =>
        authed
          ? <Redirect to={{ pathname: Redirections.ROUTE_LINK_HOME.partial, state: { from: props.location } }} />
          : <Redirect to={{ pathname: Redirections.ROUTE_LINK_DASHBOARD.partial, state: { from: props.location } }} />
      }
    />
  );
};

const authenticate = { NoPath, OpenRoute, PublicRoute, PrivateRoute };
export default authenticate;
